import React from "react";
import editIcon from "../svg/edit.svg";
import deleteIcon from "../svg/delete.svg";

function Colleges(props) {
  const offices = props.offices;
  const activeOffice = props.activeOffice;
  return (
    <div className="h-[50%] flex flex-col gap-2 xl:h-full flex-1">
      <div className="flex items-center gap-2">
        <h3 className="text-sm font-semibold text-slate-600 uppercase tracking-wide">Colleges</h3>
        {offices.length > 0 && (
          <span className="text-xs bg-sky-100 text-sky-700 font-semibold px-2 py-0.5 rounded-full">
            {offices.length}
          </span>
        )}
      </div>
      <div className="flex-1 h-auto bg-slate-50 border border-slate-200 overflow-y-auto overflow-x-hidden rounded-xl">
        {offices.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full text-slate-400 gap-2 py-8">
            <svg className="h-10 w-10 opacity-40" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" />
            </svg>
            <span className="text-sm">No colleges found</span>
          </div>
        ) : (
          offices.map((val, key) => {
            const isActive = val.idOffice === activeOffice;
            return (
              <div
                className={`flex flex-row gap-1 p-2 mx-1 my-1 rounded-lg cursor-pointer transition-colors border-l-4 ${
                  isActive
                    ? "bg-sky-100 border-sky-500"
                    : "border-transparent hover:bg-sky-50 hover:border-sky-200"
                }`}
                key={key}
              >
                <div
                  className="flex-1 w-auto flex flex-col"
                  onClick={() => {
                    props.getPrograms(val.idOffice);
                  }}
                >
                  <h4 className={`font-bold text-base ${isActive ? "text-sky-800" : "text-slate-800"}`}>
                    {val.shortName}
                  </h4>
                  <p className="text-sm text-slate-500">{val.name}</p>
                </div>
                <div className="flex flex-row gap-1 items-center">
                  <button
                    className="p-1.5 rounded-lg hover:bg-sky-100 transition-colors"
                    onClick={() => {
                      props.getPrograms(val.idOffice);
                      props.editCollege();
                    }}
                    title="Edit college"
                  >
                    <img className="h-4 w-4" src={editIcon} alt="Edit" />
                  </button>
                  <button
                    className="p-1.5 rounded-lg hover:bg-red-100 transition-colors"
                    title="Delete college"
                  >
                    <img className="h-4 w-4" src={deleteIcon} alt="Delete" />
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
      <div>
        <button
          className="flex items-center gap-1.5 bg-sky-600 hover:bg-sky-700 active:bg-sky-800 text-white text-sm font-semibold rounded-lg py-2 px-5 transition-colors shadow-sm"
          onClick={props.newCollege}
        >
          <span className="text-lg leading-none">+</span> New College
        </button>
      </div>
    </div>
  );
}

export default Colleges;
